'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UserMenuItems = exports.UserConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserConstants = exports.UserConstants = (0, _keymirror2.default)({
    USER_CHANGE: null,
    USER_CHANGE_SUCCESS: null,
    USER_CHANGE_FAIL: null,

    USER_CHANGE_MAIL: null,
    USER_CHANGE_MAIL_SUCCESS: null,
    USER_CHANGE_MAIL_FAIL: null,

    USER_CHANGE_MAIL_CODE: null,
    USER_CHANGE_MAIL_CODE_SUCCESS: null,
    USER_CHANGE_MAIL_CODE_FAIL: null,

    USER_CHANGE_PHONE: null,
    USER_CHANGE_PHONE_SUCCESS: null,
    USER_CHANGE_PHONE_FAIL: null,

    USER_CHANGE_PHONE_CODE: null,
    USER_CHANGE_PHONE_CODE_SUCCESS: null,
    USER_CHANGE_PHONE_CODE_FAIL: null,

    USER_CHANGE_INN: null,
    USER_CHANGE_INN_SUCCESS: null,
    USER_CHANGE_INN_FAIL: null,

    USER_CHANGE_UL_NAME: null,
    USER_CHANGE_UL_NAME_SUCCESS: null,
    USER_CHANGE_UL_NAME_FAIL: null,

    USER_CONFIRM_MAIL: null,
    USER_CONFIRM_MAIL_SUCCESS: null,
    USER_CONFIRM_MAIL_FAIL: null,

    USER_CONFIRM_MAIL_CODE: null,
    USER_CONFIRM_MAIL_CODE_SUCCESS: null,
    USER_CONFIRM_MAIL_CODE_FAIL: null,

    USER_CONFIRM_PHONE: null,
    USER_CONFIRM_PHONE_SUCCESS: null,
    USER_CONFIRM_PHONE_FAIL: null,

    USER_CONFIRM_PHONE_CODE: null,
    USER_CONFIRM_PHONE_CODE_SUCCESS: null,
    USER_CONFIRM_PHONE_CODE_FAIL: null,

    USER_RESET_ERROR: null,

    USER_CHANGE_PASSWORD: null,
    USER_CHANGE_PASSWORD_SUCCESS: null,
    USER_CHANGE_PASSWORD_FAIL: null,

    USER_CONFIRM_MAIL_BY_SIGNATURE: null,
    USER_CONFIRM_MAIL_BY_SIGNATURE_SUCCESS: null,
    USER_CONFIRM_MAIL_BY_SIGNATURE_FAIL: null,

    USER_ADD_ADDRESS: null,
    USER_ADD_ADDRESS_SUCCESS: null,
    USER_ADD_ADDRESS_FAIL: null
});

var UserMenuItems = exports.UserMenuItems = [{ id: 1, name: 'Личный кабинет', link: '/personal/profile', showNotification: true, lang_mark: 'store.auth_header.user_menu_items.profile' }, { id: 2, name: 'Список заказов', link: '/personal/order-list', lang_mark: 'store.auth_header.user_menu_items.order_list' }, { id: 7, name: 'Адреса', link: '/personal/addresses', lang_mark: 'store.auth_header.user_menu_items.addresses' }, { id: 3, name: 'Выписка по счёту', link: '/personal/operations', lang_mark: 'store.auth_header.user_menu_items.operations' }, { id: 4, name: 'Корзина', link: '/personal/basket', lang_mark: 'store.auth_header.user_menu_items.cart' }, { id: 5, name: 'Избранное', link: '/personal/wishlist', lang_mark: 'store.auth_header.user_menu_items.favorites' }, { id: 6, name: 'Выйти', link: '', method: 'logout', lang_mark: 'store.auth_header.user_menu_items.logout' }];


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/user.js
// module id = 1882
// module chunks = 0